import React, { useEffect, useState } from "react";
import "./EIR.css";
import { formatToDate, formatToTime } from "../pages/main/formatToDateTime";
import { useSearchParams } from "react-router-dom";
import {ImgBaseURL } from "../Config";
// export default function EIRMain({ data }, ref) {
//   if (!data) {
//     return <div  ref={ref} className="text-center p-4">No data available</div>;
//   }

export default function EIRMain() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = searchParams.get("data");
    if (params) {
      setData(JSON.parse(params));
    }
  }, [searchParams]);

  if (!data) {
    return <div className="text-center p-4">No data available</div>;
  }

  return (
    <>
      <div className="A5 m-auto main-p p-2 px-5">
        <div className="row justify-content-center align-items-center">
          <div className="col-8 text-center mb-5">
            <h1 className="m-0 h1">EQUIPMENT INTERCHANGE REPORT</h1>
          </div>
          <div className="col-12 mb-4">
            <div className="row">
              <div className="col-6">
                <p>
                  <b>No. {data.id || "N/A"}</b>
                </p>
              </div>
              <div className="col-6 text-end"></div>
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="row">
              <div className="col-6">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Date.</label>
                  <input
                    type="text"
                    className="form-control border-bottom-dash"
                    name="eir_date"
                    value={formatToDate(data.created_at) || "N/A"}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-6 text-end">
                <div className="d-flex align-items-end justify-content-end">
                  <label htmlFor="">Time</label>
                  <input
                    type="text"
                    className="form-control border-bottom-dash"
                    name="eir_time"
                    value={formatToTime(data.created_at) || "N/A"}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="d-flex align-items-end">
              <label htmlFor="">Container&nbsp;No.</label>
              <input
                type="text"
                className="form-control border-bottoms"
                value={data.container_no ?? data.ctrno ?? "N/A"}
                name="eir_container_no"
                readOnly
              />
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="row">
              <div className="col-7">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Size</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={data.container_size ?? data.ctrsize ?? "N/A"}
                    name="eir_container_size"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-5">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Type</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={data.container_type || "N/A"}
                    name="eir_container_type"
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="row">
              <div className="col-4">
                <div className="d-flex align-items-end">
                  <label htmlFor="">SLine</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={data.slinecd || "N/A"}
                    name="eir_gate_no"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Lorry/WagonNo.</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={(
                      data.vehicle_no ||
                      data.wagon_no ||
                      "N/A"
                    ).toUpperCase()}
                    name="eir_vehicle_no"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Rake No.</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={(
                      data.train_no ||
                      "rake_id_" + data.rake_id ||
                      "N/A"
                    ).toUpperCase()}
                    name="eir_vehicle_no"
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="row">
              <div className="col-5">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Status</label>
                  <input
                    type="text"
                    className="form-control border-bottoms text-primary"
                    value={data.is_container_damage.toUpperCase() ?? "N/A"}
                    name="eir_containerStatus"
                    readOnly
                  />
                </div>
              </div>

              <div className="col-4">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Camera Inferred Seal No (1)</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={data.seal_1_no || "N/A"}
                    name="eir_seal_1_no"
                    readOnly
                    style={{ cursor: "pointer" }}
                    data-bs-toggle="modal"
                    data-bs-target="#View-Modal"
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="d-flex align-items-end">
                  <label htmlFor="">(2)</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={data.seal_2_no || "N/A"}
                    name="eir_seal_2_no"
                    readOnly
                    style={{ cursor: "pointer" }}
                    data-bs-toggle="modal"
                    data-bs-target="#View-Modal"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-4">
            <div className="d-flex align-items-end mt-2">
              <label htmlFor="">CCLS Seal</label>
              <input
                type="text"
                className="form-control border-bottoms"
                value={(data.ccls_seal_no ?? data.sealno) || "N/A"}
                name="eir_seal_1_no"
                readOnly
              />
            </div>
          </div>

          <div className="col-8 mb-3">
            <div className="d-flex align-items-end">
              <label htmlFor="">Remark</label>
              <input
                type="text"
                className="form-control border-bottoms"
                value={data.damage_remark || "N/A"}
                name="eir_damage_remark"
                readOnly
              />
            </div>
          </div>

          {/* Damage Sections - Uncomment if needed */}
          {/* <div className="col-12 mb-3">
            <div className="d-flex align-items-end">
              <label htmlFor="">Rear</label>
              <input type="text" className="form-control border-bottoms" name="eir_rear" />
            </div>
          </div> */}
          {/* ... other damage sections ... */}

          <div className="col-12 mb-4">
            <div className="d-flex align-items-end">
              <label htmlFor="">
                IMO&nbsp;Stickers&nbsp;:&nbsp;Found/Not&nbsp;Found
              </label>
              <input
                type="text"
                className="form-control border-bottoms"
                value={data.imo_stickers || "N/A"}
                name="eir_imo_stickers"
                readOnly
              />
              <label htmlFor="">Removed/Not&nbsp;Removed</label>
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="row">
              <div className="col-7">
                <label htmlFor="">
                  Fot O.T Container : 1 Tarpaulin available
                </label>
              </div>
              <div className="col-5">
                <label htmlFor="">
                  {data.tarpaulin_available ? "Yes" : "No"}
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 mb-4">
            <div className="d-flex align-items-end">
              <label htmlFor="">Condition&nbsp;of&nbsp;Tarpaulin</label>
              <input
                type="text"
                className="form-control border-bottoms"
                value={data.tarpaulin_condition || "N/A"}
                name="eir_condition_of_tarpaulin"
                readOnly
              />
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="d-flex align-items-end">
              <label htmlFor="">No.&nbsp;of&nbsp;Rods&nbsp;Available</label>
              <input
                type="text"
                className="form-control border-bottoms"
                value={data.rods_available || "N/A"}
                name="eir_no_of_rods_available"
                readOnly
              />
              <label htmlFor="">{data.rods_fitted ? "Fitted" : "Loose"}</label>
            </div>
          </div>
          <div className="col-12 mb-3">
            <div className="row">
              <div className="col-12">
                <label htmlFor="">CSC Details :</label>
              </div>
            </div>
          </div>
          <div className="col-12 mb-4">
            <div className="row">
              <div className="col-5">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Date&nbsp;of&nbsp;Mfg.</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={formatToDate(data.manufacture_date) || "N/A"}
                    name="eir_date_of_mfg"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-7">
                <div className="d-flex align-items-end">
                  <label htmlFor="">Next&nbsp;Date&nbsp;of&nbsp;Exmm.</label>
                  <input
                    type="text"
                    className="form-control border-bottoms"
                    value={formatToDate(data.next_inspection_date) || "N/A"}
                    name="eir_next_date_of_exm"
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="View-Modal"
        tabIndex={-1}
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header bg-label-primary py-3">
              <h5 className="modal-title" id="exampleModalLabel1">
                Seal Image
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row">
                {data?.seal_1_image && (
                  <div className="col-4">
                    <img
                      src={ImgBaseURL + "/" + data?.seal_1_image}
                      className="w-100"
                      alt=""
                    />
                  </div>
                )}

                {data?.seal_2_image && (
                  <div className="col-4">
                    <img
                      src={ImgBaseURL + "/" + data?.seal_2_image}
                      className="w-100"
                      alt=""
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer bg-label-primary py-3">
              <button
                type="button"
                className="btn btn-outline-secondary waves-effect"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
